import Head from 'next/head';
import PropTypes from 'prop-types';

const SeoHead = ({
  title,
  description,
  keywords,
  ogTitle,
  ogDescription,
  ogImageUrl,
  ogType = 'website',
  ogLocale = 'de_DE',
  twitterTitle,
  twitterDescription,
  twitterImageUrl,
  twitterCard = 'summary_large_image',
  structuredData,
  canonicalUrl,
  children,
}) => {
  return (
    <Head>
      {title && <title>{title}</title>}
      {description && (
        <meta key="description" name="description" content={description} />
      )}
      {canonicalUrl && (
        <link rel="canonical" href={canonicalUrl} key="canonicalUrl" />
      )}
      {canonicalUrl && (
        <meta property="og:url" content={canonicalUrl} key="og:url" />
      )}
      {(ogTitle || title) && (
        <meta property="og:title" content={ogTitle || title} key="og:title" />
      )}
      {(ogDescription || description) && (
        <meta
          property="og:description"
          content={ogDescription || description}
          key="og:description"
        />
      )}
      {ogImageUrl && (
        <>
          <meta property="og:image" content={ogImageUrl} key="og:image" />
          <meta
            property="og:image:secure_url"
            content={ogImageUrl}
            key="og:image:secure_url"
          />
        </>
      )}
      <meta property="og:type" content={ogType} key="og:type" />
      <meta property="og:locale" content={ogLocale} key="og:locale" />
      <meta name="twitter:card" content={twitterCard} key="twitter:card" />
      {twitterTitle && (
        <meta name="twitter:title" content={twitterTitle} key="twitter:title" />
      )}
      {twitterDescription && (
        <meta
          name="twitter:description"
          content={twitterDescription}
          key="twitter:description"
        />
      )}
      {twitterImageUrl && (
        <meta
          name="twitter:image"
          content={twitterImageUrl}
          key="twitter:image"
        />
      )}
      {keywords && <meta name="keywords" content={keywords} key="keywords" />}
      {structuredData && (
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(structuredData),
          }}
          key="page-jsonld"
        />
      )}
      {children}
    </Head>
  );
};

SeoHead.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  keywords: PropTypes.string,
  ogTitle: PropTypes.string,
  ogDescription: PropTypes.string,
  ogImageUrl: PropTypes.string,
  ogType: PropTypes.string,
  ogLocale: PropTypes.string,
  twitterTitle: PropTypes.string,
  twitterDescription: PropTypes.string,
  twitterImageUrl: PropTypes.string,
  twitterCard: PropTypes.string,
  structuredData: PropTypes.object,
  canonicalUrl: PropTypes.string,
  children: PropTypes.node,
};

export default SeoHead;
